import React from 'react';
import { AwardIcon, CheckCircle2Icon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-navy-900 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-122" data-mp="1jas22qc1cn10">
      <div className="mx-auto max-w-3xl px-4" data-id="element-123" data-mp="1s9n5xvrlxl15">
        <SectionHeading id="pricing-title" data-id="element-124" data-mp="1s8c25vy5wda1">Choose Your <span className="text-fiber" data-id="element-125" data-mp="1x8qcjkn8jzb8">Option</span></SectionHeading>

        <article className="mt-10 overflow-hidden rounded-2xl border border-gold/70 bg-navy-950 shadow-2xl shadow-black/50" data-id="element-126" data-mp="1x9hx80faocmq">
          <div className="border-b border-line bg-navy-900/60 px-6 py-4 sm:px-10" data-id="element-127" data-mp="225gp3xzu0crw">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-gold/15 px-2.5 py-1 text-xs font-semibold text-gold" data-id="element-128" data-mp="2ws4hm0nx9gx">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-129" data-mp="1mgepdpkjr6fp" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-130" data-mp="1hpoha4kqkphb">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-131" data-mp="1hon7s4jdcb1p">
              <div data-id="element-132" data-mp="1cr4uk1ybj9nw">
                <h3 className="text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-133" data-mp="1coin02bfgu5o">{productShortName}</h3>
                <p className="mt-2 text-sm text-silver" data-id="element-134" data-mp="25fajl0wenktj">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-135" data-mp="20emtchg0380d">
                <span className="text-sm text-silver" data-id="element-136" data-mp="1vg1p86xmo46n">
                  Regular price: <span className="line-through decoration-gold decoration-2" data-id="element-137" data-mp="1rgatdot8uxv9">{priceBefore}</span>
                </span>
                <p className="mt-2 text-sm font-semibold text-fiber" data-id="element-138" data-mp="k38y8ycnvjrn">Today:</p>
                <p className="mt-1 whitespace-nowrap text-5xl font-bold leading-none tracking-tight text-gold sm:text-6xl" data-id="element-139" data-mp="g02wo40hugri">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} arrow className="mt-9 w-full" data-id="element-140" data-mp="hfx4f97lgneb">
              Get my professional edition now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-silver" data-id="element-141" data-mp="ciew9l1eic7d">
              {['Secure payment', 'Instant access', '7-day guarantee'].map(item => <span key={item} className="inline-flex items-center gap-1.5" data-id="element-142" data-mp="3uul4is7pvrgj">
                  <CheckCircle2Icon className="h-4 w-4 text-fiber" aria-hidden="true" data-id="element-143" data-mp="3jjo43esqs1f" /> {item}
                </span>)}
            </div>
          </div>
        </article>
      </div>
    </section>;
}